import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'


@Injectable({
  providedIn: 'root'
})
export class AlertViewService {

  constructor() { }





  showErrorAlert(msg) {
    Swal.fire({
      icon: 'error',
      text: msg,
      confirmButtonColor: '#28A745',
    })
  }


  showGoodAlert(msg) {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Success !',
        text: msg,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#28A745'

      })
    })
  }









  removeEventAlert(msg, repeat) {
    return new Promise((resolve) => {
      Swal.fire({
        title: msg,
        text: "予定を削除します。よろしいですか？",
        showConfirmButton: repeat != null ? true : false,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: '以降の予定を全て削除',
        denyButtonText: `この予定を削除`,
        cancelButtonText: `キャンセル`,
        confirmButtonColor: '#d33',

      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          resolve(false);
          this.showGoodAlert('予定は削除されました');
        } else if (result.isDenied) {
          resolve(true);
          this.showGoodAlert('予定は削除されました');
        }
      })
    })
  }


  dismiss() {
    Swal.close();
  }

  notifyPromise(msg) {
    return new Promise((resolve) => {
      Swal.fire({
        position: 'top',
        text: msg,
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        resolve(true);
      })
    });
  }

  notify(msg) {
    Swal.fire({
      position: 'top',
      text: msg,
      showConfirmButton: false,
      timer: 1500
    })
  }

  showYesNoAlertDelete(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: "「" + name + "」を削除します。よろしいですか？",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          this.showGoodAlert(name + 'の削除を成功しました');

          resolve(true);



        }
      })
    });
  }

  showYesNoAlertForPatientDelete(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: "「" + name + "」を非表示にします。よろしいですか？",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          this.showGoodAlert(name + 'を非表示にしました');

          resolve(true);



        }
      })
    });
  }


  showYesNoAlertAdd(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: "「" + name + "」を追加します。よろしいですか？",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#28A745'
      }).then((result) => {
        if (result.isConfirmed) {

          this.showGoodAlert(name + 'の追加を成功しました');
          resolve(true);



        }
      })
    });
  }


  showYesNoAlert(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: name,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#28A745'
      }).then((result) => {
        if (result.isConfirmed) {

          this.showGoodAlert(name + 'の追加を成功しました');
          resolve(true);



        }
      })
    });
  }

  showYesNoAlertComfirmed(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: name,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#28A745'
      }).then((result) => {
        if (result.isConfirmed) {

          this.showGoodAlert('確定処理を実行しました');
          resolve(true);



        }
      })
    });
  }


  showYesNoInviteAlertAdd(name) {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: name + "に招待メールを送信します。よろしいですか？",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#28A745'

      }).then((result) => {
        if (result.isConfirmed) {
          this.showGoodAlert('招待メールを送信しました');

          resolve(true);



        }
      })
    });
  }


  showYesNoInviteReadAll() {
    return new Promise((resolve) => {
      Swal.fire({
        title: '確認',
        text: "全てのメッセージを既読状態にします。よろしいですか？",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        confirmButtonColor: '#28A745'

      }).then((result) => {
        if (result.isConfirmed) {


          resolve(true);



        }
      })
    });
  }

  showLoading() {

    Swal.fire({
      title: '読み込み中...',
      backdrop: false,
      // timer: 2000,
      // timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()

      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        // console.log('I was closed by the timer')
      }
    })
  }



}
